import React, { useState } from "react";
import AnimatedDialogLayout from "./AnimatedDialogLayout";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { ReactComponent as PropertyTypeFilterIcon } from "assets/icons/property_type_filter.svg";
import PropertyTypeFilter from "pages/Research/components/PropertyTypeFilter";
import PriceFilter from "pages/Research/components/PriceFilter";
import SurfaceFilter from "pages/Research/components/SurfaceFilter";
import RoomFilter from "pages/Research/components/RoomFilter";
import BathroomsFilter from "pages/Research/components/BathroomsFilter";
import FloorFilter from "pages/Research/components/FloorFilter";
import useSearchFilter from "hooks/useSearchFilter";
import BedroomFilter from "pages/Research/components/BedroomFilter";

const SearchMobileFilterDialog = () => {
  const { openSearchMobileFilterDialog, toggleSearchMobileFilterDialog } =
    useSearchFilter();

  // Prevent clicks within filter components from closing the dialog
  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  return (
    <AnimatedDialogLayout
      isOpen={openSearchMobileFilterDialog}
      onClose={toggleSearchMobileFilterDialog}
    >
      <div className="" onClick={handleContentClick}>
        <div className="flex items-center justify-between">
          <h2 className="text-[20px] font-semibold text-black">Filtri</h2>
          <span
            className="cursor-pointer"
            onClick={toggleSearchMobileFilterDialog}
          >
            <CloseIcon />
          </span>
        </div>
        <hr className="h-[1px] w-full bg-gray-50 mt-3" />
        <div className="flex flex-col space-y-3 mt-4">
          {/* Property type filter  */}
          <PropertyTypeFilter />

          {/* Price filter  */}
          <PriceFilter />

          {/* Surface filter */}
          <SurfaceFilter />

          {/* Locals Filter  */}
          <RoomFilter />

          {/* Bedrooms Filter  */}
          <BedroomFilter />

          {/* Bathrooms Filter  */}
          <BathroomsFilter />

          {/* Floor Filter  */}
          <FloorFilter />

          <button
            disabled
            className="w-full lg:hidden disabled:bg-gray-300 disabled:cursor-not-allowed mb-4 inline-flex bg-primary mt-[15px] items-center justify-center space-x-[10px]  rounded-[8px] h-[38px] hover:opacity-90 duration-300 ease-in-out"
          >
            <p className="text-white font-semibold text-[12px]">Search</p>
          </button>
        </div>
      </div>
    </AnimatedDialogLayout>
  );
};

export default SearchMobileFilterDialog;
